import React from 'react';
import { connect } from "react-redux";
import Loader from './../../../Global/loader.js'
import { FaPlus } from 'react-icons/fa'
import { store } from 'react-notifications-component';
import BootstrapTable from 'react-bootstrap-table-next';
import { AiFillEdit } from 'react-icons/ai'
import { RiDeleteBin5Line } from 'react-icons/ri'
import Modal from 'react-modal'
import deleteArticle from './../../../API/Admin/DeleteArticle'
import { Button } from 'react-bootstrap'
import CreateArticle from './CreateArticle.js'
import UpdateArticle from './UpdateArticle.js'
import articlesList from './../../../API/Admin/GetArticleList'
import { BsBackspaceFill } from 'react-icons/bs'

class Artikli extends React.Component {
    state={
        loading: true,
        create: false,
        showDeleteModal: false,     
        uuidForDelete: "",  
        showOneArticle: false,
        
        customStyles: {
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                //marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                color: 'red'
            }
        },

        columns:[{
            dataField: 'naziv',
            text: 'Naziv',
            style: {wordWrap: "break-word"}  ,
            headerStyle: {wordWrap: "break-word"}         
          }, {
            dataField: 'sifra',
            text: 'Šifra',
            style: {wordWrap: "break-word"} ,
            headerStyle: {wordWrap: "break-word"} 
        }, {
          dataField: 'kataloski_broj',
          text: 'Kat. broj',
          style: {wordWrap: "break-word"} ,
          headerStyle: {wordWrap: "break-word"} 
        }, {
            dataField: 'jed_kolicina',
            text: 'Količina',
            style: {wordWrap: "break-word"} ,
            headerStyle: {wordWrap: "break-word"} 
        }, {
            dataField: 'jed_mjera',
            text: 'Mjera',
            style: {wordWrap: "break-word"} ,
            headerStyle: {wordWrap: "break-word"} 
        },{
            dataField: 'taxRate',
            text: 'Porez',
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"} 
        },{
            dataField: 'dodatni_naziv',
            text: 'Opis',
            style: {wordWrap: "break-word"} ,
            headerStyle: {wordWrap: "break-word"} 
        },
        {
            dataField: 'pregled',
            isDummyField: true,
            text: '',
            headerStyle: (colum, colIndex) => {
                return { width: '11em' };
            },
            formatter: (cellContent, row) => {          
              return (
                <div key={row.uuid} style={{wordWrap: "break-word"}}>
                    <div 
                        className="btn btn-warning" 
                        id={row.uuid} 
                        onClick={() =>this.seeDetails(row)} 
                        style={{marginBottom: "10px", marginRight: "10px", fontSize: "13px"}}
                    > 
                        <AiFillEdit /> Detalji 
                    </div> 

                    <div 
                        className="btn btn-danger"
                        id={row.uuid}
                        onClick={() => this.showDeleteModal(row.uuid)}
                        style={{marginBottom: "10px", fontSize: "13px"}}
                    >
                        <RiDeleteBin5Line /> Izbriši
                    </div> 
                   
                </div>
                
              );
            }
        }]        
        
    }

    componentDidMount = async () => {
        this.setState({loading: true})    
        let lista = await articlesList(this.props.oneClientInfo.uuid)
        if(lista.data.length > 0){
            this.props.mapState("ADMIN_MAP_ARTICLE_LIST", lista.data)
        }
        else{
           this.props.mapState("ADMIN_MAP_ARTICLE_LIST", [])
           
        }

        this.setState({
            loading: false
        })
         
    }

    toggleCreate(){
        this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        this.componentDidMount()
    }

    showDeleteModal = uuid => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            uuidForDelete: uuid
        });
    };

    confirmDelete = async () => {
        let deletedArticle = await deleteArticle(this.props.oneClientInfo.uuid, this.state.uuidForDelete)   
        if(deletedArticle.data.operationResult !== "SUCCESS"){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })     
            await store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom brisanja Artikla, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            }) 

            await store.addNotification({
                title: "Uspješno!",
                message: "Brisanje Artikla je izvršeno.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.componentDidMount()
        }
    }

    seeDetails = async (data) => {
        await this.props.mapState("ADMIN_MAP_ONE_ARTICLE", data)
        await this.setState({
            showOneArticle: !this.state.showOneArticle
        })
    }

    backFromEdit = async () =>{
        await this.setState({
            showOneArticle: !this.state.showOneArticle
        })

        this.componentDidMount()
    }

    goBack(){
        window.location = "#/Admin/client/"
    }
   
    render(){  
        const { loading, create, showOneArticle } = this.state 

    return (
        <>
        {loading ? 
            <Loader />
        :
            <>
                {showOneArticle? 
                    <UpdateArticle goBack={() => this.backFromEdit()} />
                :
                create ? 
                    <CreateArticle goBack={() => this.backFromCreate()} />
                :
                    <>
                        <div style={{padding:"20px", float: "right"}}>
                            <div className="btn btn-success" style={{fontSize: "16px"}} onClick={() => this.toggleCreate()}>
                                <FaPlus size={20} /> <span style={{verticalAlign: "middle"}} >Kreiraj</span>
                            </div>
                        </div>

                        <BootstrapTable
                            keyField="uuid" 
                            data={ this.props.articleList } 
                            columns={ this.state.columns }   
                            bodyStyle={{wordBreak: 'break-word'} }                    
                        />

                        <Modal
                            isOpen={this.state.showDeleteModal}                
                            onRequestClose={() => this.showDeleteModal("")}
                            style={this.state.customStyles}
                            contentLabel="Example Modal"
                        >
            
                            <h1 style={{padding:"20px"}}><strong>Upozorenje!</strong></h1>
                        
                            <div className="" style={{padding: "20px"}}>
                                Brisanjem poslovnog prostora obrisat će se i ostali podaci koji su vezani uz njega.                                
                            </div>

                            <div className="row">
                                <div className="col col-sm-6">
                                    <Button variant="primary" size="lg" onClick={() => this.showDeleteModal("")}>Zatvori</Button>
                                </div>
                                <div className="col col-sm-6">
                                    <Button variant="danger" size="lg" onClick={() => this.confirmDelete()}> IZBRIŠI</Button>
                                </div>                
                            </div>
                    
                        </Modal> 
                        
                        <div 
                            className="btn btn-default" 
                            style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                            onClick={() => this.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>Nazad</strong>                    
                        </div>   
                    </>
                }
                                
            </>
            
        }
        </>
    )
}
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        articleList: state.adminClient.articleList,
        oneArticle: state.adminClient.oneArticle
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Artikli);